import React, { useEffect, useState } from "react";
import { DebounceInput } from "react-debounce-input";
import ReactPaginate from "react-paginate";

import { PGET } from "../../../api/adminApi";

function formatDate(value) {
    if (!value) return "-";
    // ISO yoki timestamp matnidan sana + vaqtni qisqartirib ko'rsatamiz
    const str = String(value).replace("T", " ");
    return str.length > 16 ? str.substring(0, 16) : str;
}

function GiftStatusBadge({ status }) {
    if (!status) {
        return <span className="badge bg-secondary">—</span>;
    }
    const lower = String(status).toLowerCase();
    let cls = "bg-info";
    if (lower === "delivered") cls = "bg-success";
    else if (lower === "ready_for_delivery") cls = "bg-primary";
    else if (lower.includes("cancel")) cls = "bg-danger";
    return <span className={`badge ${cls}`}>{status}</span>;
}

function GiftOrders() {
    const [items, setItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [value, setValue] = useState("");
    const [currentPage, setCurrentPage] = useState(
        +localStorage.getItem("currentPageGiftOrders") || 0
    );

    const handleSearchInput = (e) => {
        setValue(e.target.value);
        setCurrentPageToZero();
    };

    function setCurrentPageToZero() {
        setCurrentPage(0);
        localStorage.setItem("currentPageGiftOrders", 0);
    }

    function paginate(data) {
        setCurrentPage(data.selected);
        localStorage.setItem("currentPageGiftOrders", data.selected);
    }

    async function getItems() {
        const data = await PGET("/services/admin/api/gift-orders-admin", true, {
            page: currentPage,
            size: 10,
            search: value,
        });
        setPageCount(Math.ceil(data.headers["x-total-count"] / 10));
        setItems(data.data);
    }

    useEffect(() => {
        getItems();
    }, [currentPage, value]); // eslint-disable-line react-hooks/exhaustive-deps

    const headStyle = { backgroundColor: "#E7372C", fontWeight: "700" };

    return (
        <div
            className="br-5 card"
            style={{ background: "#eef1ff", marginTop: "-0.9rem", height: "100vh" }}
        >
            <div className="card-header border-0 pt-5">
                <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bold fs-3 mb-1">Доставка призов</span>
                </h3>
            </div>
            <div className="px-3 pb-4 pt-2">
                <div className="mb-4 d-flex justify-content-between">
                    <div className="d-flex gap-4">
                        <div className="position-relative ">
                            <DebounceInput
                                minLength={3}
                                debounceTimeout={400}
                                value={value}
                                onChange={handleSearchInput}
                                type="text"
                                className="input-search search-icon br-5 "
                                size={24}
                                placeholder="Поиск (ФИО, телефон, приз)"
                            />
                        </div>
                    </div>
                </div>
                <div style={{ overflow: "auto", maxHeight: "75vh" }}>
                    <table className="table bg-white table-rounded p-0 border gy-4 gs-7">
                        <thead className="position-sticky top-0 rounded">
                            <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                                <th style={{ ...headStyle, borderTopLeftRadius: "8px", width: "30px" }} className="text-white text-center">№</th>
                                <th className="text-start text-white" style={headStyle}>Клиент</th>
                                <th className="text-start text-white" style={headStyle}>Телефон</th>
                                <th className="text-start text-white" style={headStyle}>Регион / Город</th>
                                <th className="text-start text-white" style={headStyle}>Приз</th>
                                <th className="text-center text-white" style={headStyle}>Дата заказа</th>
                                <th className="text-center text-white" style={headStyle}>Статус (источник)</th>
                                <th className="text-center text-white" style={headStyle}>Статус доставки</th>
                                <th className="text-center text-white" style={{ ...headStyle, borderTopRightRadius: "8px" }}>Получен</th>
                            </tr>
                        </thead>

                        <tbody style={{ overflowX: "auto" }}>
                            {items.map((item, idx) => (
                                <tr key={item.id} className="borderBottom">
                                    <td className="text-center">
                                        {currentPage === 0 ? idx + 1 : currentPage * 10 + idx + 1}
                                    </td>
                                    <td className="text-start">{item.customerName || "-"}</td>
                                    <td className="text-start">{item.customerPhone || "-"}</td>
                                    <td className="text-start">
                                        {[item.region, item.city].filter(Boolean).join(", ") || "-"}
                                    </td>
                                    <td className="text-start">{item.giftName || "-"}</td>
                                    <td className="text-center">{formatDate(item.orderDate)}</td>
                                    <td className="text-center">{item.sourceStatusName || "-"}</td>
                                    <td className="text-center">
                                        <GiftStatusBadge status={item.giftStatus} />
                                        {item.giftStatusUpdatedAt && (
                                            <div className="text-muted" style={{ fontSize: "11px" }}>
                                                {formatDate(item.giftStatusUpdatedAt)}
                                            </div>
                                        )}
                                    </td>
                                    <td className="text-center">
                                        {item.received ? (
                                            <span className="badge bg-success">Да</span>
                                        ) : (
                                            <span className="badge bg-light text-dark">Нет</span>
                                        )}
                                        {item.received && item.receivedAt && (
                                            <div className="text-muted" style={{ fontSize: "11px" }}>
                                                {formatDate(item.receivedAt)}
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            {items.length === 0 && (
                                <tr>
                                    <td colSpan={9} className="text-center text-muted py-4">
                                        Нет данных
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {pageCount > 1 && (
                    <ReactPaginate
                        forcePage={currentPage}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={1}
                        onPageChange={paginate}
                        containerClassName={"pagination"}
                        activeClassName={"bg-dark text-white"}
                        pageClassName={"page-item box-shadow"}
                    />
                )}
            </div>
        </div>
    );
}

export default GiftOrders;
